module.exports = __webpack_public_path__ + "assets/img/28-l.226c0a7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/photo/objects/28-l.jpg
// module id = RqZL
// module chunks = 0